import React from 'react';
import { validateSessionToken } from "account-portal-library/lib/helperFunctions";
import { getCallbacks } from 'account-portal-library/lib/emailSignIn.js';
import { getGotoUrlFromCookies } from '../../gotoUrl.js';
import TOVerifyCodeView from '../Views/TO/Code/VerifyCodeView';
import AppVars from '../../AppVars.js';
import axios from 'axios';

let appVars = AppVars.getInstance();

const INVALID_CREDS_URL = "/invalidcreds"
const UNKNOWN_ERROR_URL = "/unknownerror"

class VerifyCode extends React.Component {
    constructor(props) {
        super(props);
        this.state = {
            ...props,
            loading: false,
            OTPValue: "",
            isOTPValid: null,
            isCodeInvalid: false,
            isResponseValid: null,
            isCodeResent: null,
            displayUsername: sessionStorage.AP_SSID,
            onFocus: false,
            floatLabel: true,
            verificationType: this.props.signInType,
            userGuid: "",
        };
        this.submitOTP = this.submitOTP.bind(this);
        this.validateOTP = this.validateOTP.bind(this);
        this.handleOTPChange = this.handleOTPChange.bind(this);
        this.getNewOTP = this.getNewOTP.bind(this);
        this.handleSuccess = this.handleSuccess.bind(this);
        this.checkToken = this.checkToken.bind(this);
        this.handlePasswordLogin = this.handlePasswordLogin.bind(this);
        this.setFocus = this.setFocus.bind(this);
        this.removeFocus = this.removeFocus.bind(this);
        this.hideModal = this.hideModal.bind(this);
        this.onBlur = this.onBlur.bind(this);
        this.validateForm = this.validateForm.bind(this);
        this.sendJourneyPayload = this.sendJourneyPayload.bind(this);
    }

    componentDidMount() {
        if (this.props.signInType === "PHONE" || this.props.signInType === "OTP") {
            const username = sessionStorage.AP_SSID;
            let displayPhone = "";
            try {
                displayPhone = "(" + username.substring(0, 3) + ") " + username.substring(3, 6) + "-" + username.substring(6, 10)
            } catch {
                displayPhone = username;
            }
            this.setState({ displayUsername: displayPhone })
        }
    }

    async sendJourneyPayload(journeyPayload, url, headers, params) {
        try {
            const resp = await axios({ method: 'post', url, headers, params, data: journeyPayload });
            return {
                response: resp.data,
                status: resp.status
            };
        } catch (error) {
            const status = error.response?.status;
            const data = error.response?.data;
            return {
                response: data,
                status: status,
                failureUrl: status === 401 ? data?.failureUrl || UNKNOWN_ERROR_URL : UNKNOWN_ERROR_URL
            };
        }
    };

    validateForm(status) {
        if (status > 299) {
            return false;
        }
        else {
            return true;
        }
    }

    async getNewOTP() {
        debugger;
        try {
            this.setState({ isCodeInvalid: false });
            let resendPayload = this.props.payload;
            if (this.state.payload) {
                resendPayload = { ...this.state.payload };
            }
            resendPayload.callbacks[1].input[0].value = "";
            resendPayload.callbacks[2].input[0].value = 1;
            const url = appVars.getBaseUrl() + "/" + appVars.getName() + '/json' + appVars.getRealm() + '/authenticate';
            // const url = appVars.getAMBaseURL() + '/json' + appVars.getRealm() + '/authenticate';
            const params = {
                'authIndexType': 'service',
                'authIndexValue': this.props.showForm === "RESET" ? appVars.getResetPasswordTree() : appVars.getSignInTree()
            };
            const headers = {
                'Accept-API-Version': 'resource=1.1',
                'Content-Type': 'application/json',
            };
            const journeyResponse = await this.sendJourneyPayload(resendPayload, url, headers, params);
            // console.log("Journey Response(OTP Resend) -> ", journeyResponse)
            if (journeyResponse.status !== 200) {
                this.setState({ isResponseValid: false });
                throw journeyResponse.response;
            }
            this.setState({ payload: journeyResponse.response, isCodeResent: true });
        } catch (errorResponse) {
            // console.log("Error -> ", errorResponse);
            this.handleFailure(errorResponse);
        }
    }

    async submitOTP(event) {
        event.preventDefault();
        try {
            if (this.state.isOTPValid) {
                this.setState({ loading: true, isCodeInvalid: false, isResponseValid: null })
                let submitPayload = this.props.payload;
                if (this.state.payload) {
                    submitPayload = { ...this.state.payload };
                }
                submitPayload.callbacks[1].input[0].value = this.state.OTPValue;
                submitPayload.callbacks[2].input[0].value = 0;
                const url = appVars.getBaseUrl() + "/" + appVars.getName() + '/json' + appVars.getRealm() + '/authenticate';
                // const url = appVars.getAMBaseURL() + '/json' + appVars.getRealm() + '/authenticate';
                const params = {
                    'authIndexType': 'service',
                    'authIndexValue': this.props.showForm === "RESET" ? appVars.getResetPasswordTree() : appVars.getSignInTree()
                };
                const headers = {
                    'Accept-API-Version': 'resource=1.1',
                    'Content-Type': 'application/json',
                };
                const journeyResponse = await this.sendJourneyPayload(submitPayload, url, headers, params);
                // console.log("Journey Response(OTP Submit) -> ", journeyResponse)
                if (journeyResponse.status !== 200) {
                    this.setState({ isResponseValid: false });
                    throw journeyResponse.response;
                }
                else if (journeyResponse.response?.callbacks?.length === 3 || journeyResponse.response?.callbacks?.[0]?.output?.[0]?.value === "Invalid OTP") {
                    this.setState({ isCodeInvalid: true, loading: false })
                }
                else {
                    this.setState({ payload: journeyResponse.response });
                    if (journeyResponse.response?.callbacks)
                        this.handleContinue(journeyResponse.response);
                    else
                        this.handleSuccess(journeyResponse.response);
                }
            }
        } catch (errorResponse) {
            // console.log("Error -> ", errorResponse);
            this.handleFailure(errorResponse);
        }
    }

    async handleContinue(journeyResponse) {
        this.props.saveCode(this.state.OTPValue);
        this.props.savePayload(journeyResponse);
        this.props.displayForm("PASSWORD");
    }

    async handlePasswordLogin() {
        try {
            const url = appVars.getBaseUrl() + "/" + appVars.getName() + '/json' + appVars.getRealm() + '/authenticate';
            // const url = appVars.getAMBaseURL() + '/json' + appVars.getRealm() + '/authenticate';
            const params = {
                'authIndexType': 'service',
                'authIndexValue': appVars.getSignInTree()
            };
            const headers = {
                'Accept-API-Version': 'resource=2.0',
                'Content-Type': 'application/json',
            };
            const startJourney = await getCallbacks(url, headers, params);
            const initialResponse = startJourney.response;

            const username = sessionStorage.AP_SSID;
            const otpUsername = this.props.signInType === "OTP" ? ("noverify-" + username) : username;

            if (startJourney.status < 299) {
                initialResponse.callbacks[0].input[0].value = otpUsername;
                initialResponse.callbacks[1].input[0].value = "TO";
            }

            const journeyResponse = await this.sendJourneyPayload(initialResponse, url, headers, params);
            // console.log("CheckUsername JourneyResponse -> ", journeyResponse)

            if (journeyResponse.status !== 200) {
                this.setState({ isResponseValid: false });
                throw journeyResponse.response;
            }
            this.props.savePayload(journeyResponse.response);
            this.props.displayForm("PASSWORD");
        } catch (errorResponse) {
            // console.log("Error -> ", errorResponse);
            this.handleFailure(errorResponse);
        }
    }

    validateOTP(code) {
        if (code == null || code.trim().length != 6) {
            return false;
        } else {
            return !isNaN(code);
        }
    }

    handleOTPChange(value) {
        this.setState({ OTPValue: value }, () => {
            // Wipe the invalid verification after typing
            if (this.state.isCodeInvalid) {
                this.setState({ isCodeInvalid: false })
            }
            // Wipe the resent notification after typing
            if (this.state.isCodeResent) {
                this.setState({ isCodeResent: false })
            }
            // Error message was previously showing but now the code is a valid OTP so remove it
            if (this.state.isOTPValid !== true && this.validateOTP(value)) {
                this.setState({ isOTPValid: true })
            } // If the otp valid state was valid but is no longer valid update the error message
            else if (this.state.isOTPValid === true && !this.validateOTP(value)) {
                this.setState({ isOTPValid: false })
            }
        });
    }

    //Checks that there is a session cookie on the browser
    async checkToken(journeyResponse) {
        try {
            const tokenId = journeyResponse.tokenId;
            if (tokenId != null) {
                // console.log("Token ID -> ", tokenId)
                const validateResponse = await validateSessionToken(tokenId, appVars.getBaseUrl(), appVars.getName(), appVars.getRealm());
                // console.log("validateResponse -> ", validateResponse);
                return validateResponse.response.valid;
            } else {
                return false;
            }
        }
        catch {
            return false;
        }

    }

    handleFailure(journeyResponse) {
        var failureUrl = journeyResponse.failureUrl;
        //If invalid credentials
        if (failureUrl === INVALID_CREDS_URL) {
            this.setState({ isLoginValid: false })
            this.setState({ loading: false })
        }
        //If invalid credentials
        else if (failureUrl != null) {
            window.location.replace(failureUrl);
        }
        else {
            //this.setState({loading: false})
            window.location.replace(appVars.getUnknownErrorURL(this.props.style));
        }
    }

    async handleSuccess(journeyResponse) {
        const tokenValid = await this.checkToken(journeyResponse);
        // console.log("Token Valid -> ", tokenValid);

        if (tokenValid) {
            const gotoUrl = getGotoUrlFromCookies(['T', 'S']);
            window.location.replace(gotoUrl);
        } else {
            // Token was invalid for a successful response
            window.location.replace(appVars.getUnknownErrorURL(this.props.style));
        }
    }

    setFocus(event) {
        this.setState({ onFocus: true })
        this.setState({ floatLabel: false })
    }

    removeFocus() {
        this.setState({ onFocus: false })
    }

    onBlur() {
        if (this.state.OTPValue === "" || this.state.OTPValue === null) {
            this.setState({ floatLabel: true })
        } else {
            this.setState({ floatLabel: false })
        }
        this.removeFocus()
        this.setState({ isOTPValid: this.validateOTP(this.state.OTPValue) })
    }

    hideModal() {
        this.setState({ isResponseValid: null })
    }

    render() {
        return (
            <TOVerifyCodeView
                showForm={this.props.showForm}
                loading={this.state.loading}
                displayUsername={this.state.displayUsername}
                signInType={this.props.signInType}
                OTPValue={this.state.OTPValue}
                isCodeInvalid={this.state.isCodeInvalid}
                isOTPValid={this.state.isOTPValid}
                isCodeResent={this.state.isCodeResent}
                isResponseValid={this.state.isResponseValid}
                handleOTPChange={this.handleOTPChange}
                submitOTP={this.submitOTP}
                getNewOTP={this.getNewOTP}
                handlePasswordLogin={this.handlePasswordLogin}
                onFocus={this.state.onFocus}
                setFocus={this.setFocus}
                removeFocus={this.removeFocus}
                hideModal={this.hideModal}
                style={this.props.style}
                onBlur={this.onBlur}
                floatLabel={this.state.floatLabel}
            />
        );
    }
}

export default VerifyCode;